import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { trackEvent } from "@/lib/analytics";

const API = process.env.REACT_APP_BACKEND_URL;

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const sessionId = new URLSearchParams(location.hash.replace(/^#/, "")).get("session_id");
    const target = location.pathname + location.search;
    (async () => {
      try {
        const r = await fetch(`${API}/api/auth/session`, {
          method: "POST",
          credentials: "include",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ session_id: sessionId }),
        });
        if (r.ok) { setUser(await r.json()); trackEvent("login", { method: "google" }); }
      } finally {
        navigate(target, { replace: true });
      }
    })();
  }, [location, navigate, setUser]);

  return null;
}
